import React from 'react';

import AdminAuthContainer from './AdminAuthContainer';
import AdminIntegrationsContainer from './AdminIntegrationsContainer';
import AdminSettings from './AdminSettings';
import AdminSettingsContainer from './AdminSettingsContainer';
import AdminSsoContainer from './AdminSsoContainer';
import AdminUsersContainer from './AdminUsersContainer';
import ApiKeysContainer from './ApiKeysContainer';
import ClassesContainer from './components/Classes/ClassesContainer';
import DownloadChatContainer from './DownloadChatContainer';
import { ClassContainer } from '../ClassModal/ClassContainer';

const Admin = () => (
    <AdminAuthContainer.Provider>
        <AdminSettingsContainer.Provider>
            <AdminUsersContainer.Provider>
                <AdminIntegrationsContainer.Provider>
                    <ApiKeysContainer.Provider>
                        <AdminSsoContainer.Provider>
                            <ClassesContainer.Provider>
                                <DownloadChatContainer.Provider>
                                    <ClassContainer.Provider>
                                        <AdminSettings />
                                    </ClassContainer.Provider>
                                </DownloadChatContainer.Provider>
                            </ClassesContainer.Provider>
                        </AdminSsoContainer.Provider>
                    </ApiKeysContainer.Provider>
                </AdminIntegrationsContainer.Provider>
            </AdminUsersContainer.Provider>
        </AdminSettingsContainer.Provider>
    </AdminAuthContainer.Provider>
);

export default Admin;
